module.exports = __webpack_public_path__ + "img/GainStrength.6a57215a.png";